import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../assets/styles/Footer.scss";

const Footer = () => (
  <footer id="footer" className="footer-section unselectable">
    <Container>
      <Row>
        <Col md="4">
          <h3 className="text-dark">(주)오버더문</h3>
          <ul
            className="list-unstyled footer-links"
            style={{ fontWeight: 300 }}
          >
            <li>대표이사: 강민재</li>
            <li>사업자 등록 번호: </li>
            <li>-</li>
            {/* <li>서울특별시 강남구 역삼동 테헤란로 8길 32 타임코빌딩 5층</li>
            <li>02-3452-0328</li> */}
            <li>
              <a href="mailto:info@otmedu.com">info@otmedu.com</a>
            </li>
          </ul>
        </Col>

        <Col md="3" className="ml-auto">
          <h3 className="text-dark">링크</h3>
          <ul
            className="list-unstyled footer-links"
            style={{ fontWeight: 200 }}
          >
            <li>
              <a href="/page/about">회사소개</a>
            </li>
            <li>
              <a href="/page/agreement">이용약관</a>
            </li>
            <li>
              <a href="/page/privacypolicy">개인정보취급방침</a>
            </li>
            <li>-</li>
            <li>
              <a href="/contact/consult">상담문의</a>
            </li>
            <li>
              <a href="/contact/recruitment">채용문의</a>
            </li>
            <li>
              <a href="/auth/teacher">강사등록</a>
            </li>
            <li>-</li>
            <li>
              <a href="/auth/login">로그인</a>
            </li>
            <li>
              <a href="/auth/register">회원가입</a>
            </li>
          </ul>
        </Col>

        <Col md="4">
          <a
            href="https://www.facebook.com/academy_otm-104480150900486/"
            rel="noopener noreferrer"
            target="_blank"
            className="mr-3"
          >
            <img
              src={require("../assets/img/social_facebook.png")}
              alt="social-fb"
              width="50"
            />
          </a>
          <a
            href="https://www.instagram.com/academy_otm/"
            rel="noopener noreferrer"
            target="_blank"
            className="mr-3"
          >
            <img
              src={require("../assets/img/social_instagram.png")}
              alt="social-ig"
              width="50"
            />
          </a>
          <a
            href="https://pf.kakao.com/_xdNrsT"
            rel="noopener noreferrer"
            target="_blank"
            className="mr-3"
          >
            <img
              src={require("../assets/img/social_kakao.png")}
              width="50"
              alt="social-instagram"
            />
          </a>
          {/* <a
            href="https://discord.gg/pqx4s7Qh"
            rel="noopener noreferrer"
            target="_blank"
            className="mr-3"
          >
            <img
              src={require("../assets/img/social_discord.png")}
              width="50"
              alt="social-instagram"
            />
          </a> */}
          <a
            href="https://blog.naver.com/otm2019"
            rel="noopener noreferrer"
            target="_blank"
            className="mr-3"
          >
            <img
              src={require("../assets/img/social_naverblog.png")}
              alt="social-naver"
              width="50"
            />
          </a>
          <a
            href="https://talk.naver.com/wc12v1"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              src={require("../assets/img/social_navertalktalk.png")}
              alt="social-navertalk"
              width="50"
            />
          </a>
          <hr />
          <div className="mt-3 mb-2">
            <img
              src={require("../assets/img/ucas_official.png")}
              className="img-fluid"
              alt="ucas_official"
            />
          </div>
          <div>
            저희 오버더문은 UCAS가 공식적으로 인증한 센터로서 학생들에게
            일반적인 원서 지원절차부터 Predicted Grades, Reference, Personal
            Statement 등에 대해 전문적인 서비스 및 컨설팅을 제공해 영국대학에
            진학시키고 있습니다.
          </div>
        </Col>
      </Row>

      <Row className="pt-5 mt-5 text-center">
        <Col md="12">
          <div className="pt-3">
            <p className="copyright">
              Copyright &copy; {new Date().getFullYear()} - OverTheMoon. All
              rights reserved.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
